module.exports = __webpack_public_path__ + "media/images/area/area_kyushuM400-7edd25abba46dc5d6b3c1800b00b9ff5.jpg";